import React from "react";
import { IoDocumentOutline, IoEyeOutline } from "react-icons/io5";
import { TitleDocumentInfo } from "@Types/title_issues";
import styles from "./PreviewDocument.module.scss";

interface PreviewDocumentProps {
  title: string;
  description: string;
  data: TitleDocumentInfo;
}

export const TitleStatusChip = ({ info }: { info: TitleDocumentInfo }) => {
  const getStatusClassName = (status: string | undefined) => {
    if (status !== "resolved") return styles.statusAwaiting;
    return styles.statusResolved;
  };

  return (
    <div className={styles.statusSection}>
      <span
        className={`${styles.status} ${getStatusClassName(info.status)}`}
        role="status"
      >
        {info.status === "resolved" ? "Uploaded" : "Awaiting"}
      </span>
    </div>
  );
};
const PreviewDocument: React.FC<PreviewDocumentProps> = ({
  data,
  description,
  title,
}) => {
  const handleOpenDocument = (url: string) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <div className={styles.previewDocument}>
      {/* Header Section */}
      <div className={styles.header}>
        <div className={styles.titleSection}>
          <div className={styles.titleInfo}>
            <h3 className={styles.title}>{title}</h3>
            <p className={styles.description}>{description}</p>
          </div>
        </div>

        <TitleStatusChip info={data} />
      </div>

      {/* Documents Section */}
      {data.documents?.length > 0 && data.status === "resolved" ? (
        <div className={styles.documentsSection}>
          <h4 className={styles.documentsTitle}>
            {data.documents.length} Document
            {data.documents.length > 1 ? "s" : ""} Available
          </h4>

          <div className={styles.documentsGrid}>
            {data.documents.map((url, index) => (
              <div
                key={`document-${index}`}
                className={styles.documentCard}
                onClick={() => handleOpenDocument(url)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    handleOpenDocument(url);
                  }
                }}
                role="button"
                tabIndex={0}
                aria-label={`Open document ${index + 1}`}
              >
                <IoDocumentOutline className={styles.docIcon} size={24} />
                <div className={styles.docInfo}>
                  <span className={styles.docName}>Document {index + 1}</span>

                  <span className={styles.clickHint}>Click to view</span>
                </div>
                <IoEyeOutline className={styles.viewIcon} size={16} />
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className={styles.noDocuments}>
          <IoDocumentOutline className={styles.emptyIcon} size={32} />
          <p className={styles.emptyMessage}>No documents available</p>
        </div>
      )}
    </div>
  );
};

export default PreviewDocument;
